import { SPIFF_APPROVALS_TABS } from "./constants";

export const isValidSpiffApprovalsTab = (tab?: string | null) =>
  Object.values(SPIFF_APPROVALS_TABS).includes(
    tab as (typeof SPIFF_APPROVALS_TABS)[keyof typeof SPIFF_APPROVALS_TABS],
  );

export const getCompoundId = (spiffApprovalId: string, userId: string) =>
  `${spiffApprovalId}|${userId}`;

export const splitCompoundId = (compoundId: string) => {
  const [spiffApprovalId, userId] = compoundId.split("|");
  return { spiffApprovalId, userId };
};
